import React from 'react';
import { Helmet } from 'react-helmet';
import Auth from "../../../assets/js/utils/Auth";
import PropTypes from "prop-types";
import BackgroundSlider from "../../components/Slider/BackgroundSlider";
import GridItem from "../../components/Grid/GridItem";
import FarManagementPage from "../../components/User/Far/FarManagementPage";
import { isFarEnabled, isFarAdmin } from "../../components/User/Far/farAccess";

import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import { helper } from '../../../assets/js/utils/Element.js';

/**
 * File Attachment Rules (FAR) management — Rules / Settings / Audit Log.
 * Route: /attachment/rules (?tab=settings|audit)
 * The FAR on/off switch lives in Extensions; this page only reports it.
 */
const AttachmentRules = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;
        this.onTabChange = this.onTabChange.bind(this);
    }
    componentDidMount(){
        const { authorized, user } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
            return;
        }
        if(user.hasOwnProperty('user_type') && user.user_type !== "business"){
            let redirectUrl = helper.getHomePageUrl(user);
            if(user.level_id === 5){
                redirectUrl = "/user/shared";
            }
            this.history.push(redirectUrl);
        }
    }
    getInitialTab(){
        const tab = helper.getParam("tab");
        if(tab === "settings" || tab === "audit"){
            return tab;
        }
        return "rules";
    }
    onTabChange(tab){
        const location = this.history.location;
        const url = location.pathname+(tab === "rules" ? "" : "?tab="+tab);
        this.history.replace(url);
    }
    render() {
        const { classes } = this.props;
        const { authorized, user } = this.store.getState();
        if(!authorized || user.level_id === 5){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }

        return (
            <div className={classes.main}>
                <div className={classes.container}>
                    <div className={classes.content}>
                        <GridItem>
                            <FarManagementPage
                                enabled={isFarEnabled(user)}
                                canManage={isFarAdmin(user)}
                                initialTab={this.getInitialTab()}
                                onTabChange={this.onTabChange}
                            />
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{"File Attachment Rules | "+(process.env.REACT_APP_TITLE || "Sendlinx")}</title>
                </Helmet>
            </div>
        )
    }
}

AttachmentRules.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(AttachmentRules);
